

import XHeader from 'vux/src/components/x-header/index.vue'

import Tabbar from './components/layout/Tabbar.vue'
import TodoDialog from './views/todo/todo/components/Dialog.vue'
import MessagePopup from './views/message/message/components/Popup.vue'
export default {
name: 'app',
components: {Tabbar, TodoDialog, MessagePopup, XHeader},
data () {
return {
cachedViews: [],
title:null,






}
},
created () {
this.$store.state.bus.$on('user-logout', this.clearCachedViews)
this.$store.state.bus.$on('get-user-info', this.setCachedViews)
this.$store.state.bus.$on('party-ready', this.updateTitle)
},
methods: {
updateTitle () {
let pname = this.$store.state.party.name
let t = document.title
if (pname && !t.startsWith(pname)) {
document.title = pname + t
this.title = t === 'WECHAT_EMPTY_TITLE' ? pname : document.title
}
},
onTabChange (v) {

},
setCachedViews () {
this.cachedViews = this.$store.state.cachedViews
},

clearCachedViews () {
this.cachedViews = []
}
},
computed: {
showHeader () {
return window.navigator.userAgent.includes('WindowsWechat')
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue